// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-3yWu_","totaliser":"jgp-1xIB4"};